/**
 * Device-type detection for User Intelligence analytics.
 *
 * Returns 'mobile' / 'desktop' using the SAME 768px breakpoint as the
 * useIsMobile hook (hooks/useIsMobile.js), so the analytics device split
 * matches the breakpoint that actually drives the app's mobile UI.
 *
 * This is a plain function (not a hook) so it can be called from the axios
 * request interceptor, which attaches the result as the X-Device-Type header.
 */
export const MOBILE_BREAKPOINT = 768;

export function getDeviceType() {
  if (typeof window === 'undefined') {
    return 'desktop';
  }
  return window.innerWidth < MOBILE_BREAKPOINT ? 'mobile' : 'desktop';
}
